/* global setTimeout console */
import { fetchCheckDeletePart, fetchParentsDocumentPart } from "../../api/document/DocumentsPart";
import {
  deleteDocumentPartAsync,
  deleteDocumentRootAsync,
  DocumentPartItem,
} from "../../redux/feature/document/document-slice";
import { TreeViewDataItem } from "../../components/cpm/DocumentPartTree";
import {
  DocumentPropertiesActionTypes,
  DocumentPropertiesMessagesModal,
} from "../../components/cpm/DocumentPropertiesMessagesModal";
import React, { useEffect, useState } from "react";
import { DocumentPart } from "../../api/models";

const isNullish = (value: any) => !value;
const isHeadOfTheTreeDocument = (deleteItem: DocumentPartItem, partRoot: DocumentPart) => deleteItem.id === partRoot.id;

export const DeleteDocumentHelper = (props: {
  deleteItem?: DocumentPartItem;
  onCancelDelete: () => void;
  partRoot: DocumentPart;
  currentDocumentPartId?: string;
}) => {
  const [state, setState] = useState<{
    action: DocumentPropertiesActionTypes;
    fathersItemSelected: TreeViewDataItem[];
    numberOfChildren: number;
    deleteItem: DocumentPartItem;
  }>({ deleteItem: props.deleteItem, action: null, fathersItemSelected: null, numberOfChildren: null });

  const hidePanel = () => {
    setState({ deleteItem: null, action: null, fathersItemSelected: null, numberOfChildren: null });
    props.onCancelDelete();
  };

  useEffect(() => {
    if (!props.deleteItem) return;
    if (isHeadOfTheTreeDocument(props.deleteItem, props.partRoot)) {
      //library -> delete a root
      setState({ deleteItem: props.deleteItem, action: "confirm", fathersItemSelected: null, numberOfChildren: null });
    } else {
      checkFathers(props.deleteItem, false);
    }
  }, [props.deleteItem]);

  async function checkFathers(selectedPart: DocumentPart, response: boolean) {
    /* confirmUnlinkWillBePerformed */
    if (response) {
      await checkHasChildren(selectedPart);
      return;
    }

    console.log(selectedPart);

    if (selectedPart.root && selectedPart.multiLinked) {
      setState({
        deleteItem: selectedPart,
        action: "confirmUnlinkWillBePerformed",
        fathersItemSelected: null,
        numberOfChildren: null,
      });
    }

    let fathers: TreeViewDataItem[];
    const documentParts = await fetchParentsDocumentPart(selectedPart.id);
    fathers = documentParts.map((documentPart) => {
      return {
        key: documentPart.id,
        text: documentPart.name,
        order: documentPart.order,
        nodeType: "root",
        hasChildren: documentPart.hasChildren,
        expanded: false,
        checked: false,
        selected: false,
        items: null,
        data: documentPart,
      };
    });

    if (fathers.length > 1) {
      setState({
        deleteItem: selectedPart,
        action: "confirmNumberOfFathers",
        fathersItemSelected: fathers,
        numberOfChildren: null,
      });
    } else {
      await checkHasChildren(selectedPart);
    }
  }

  async function checkHasChildren(selectedPart) {
    const children: string[] = await fetchCheckDeletePart(selectedPart.id);
    const numberOfChildren = children.length;
    if (numberOfChildren > 1) {
      hidePanel();
      setState({
        deleteItem: selectedPart,
        action: "confirmChildrenDeletion",
        fathersItemSelected: null,
        numberOfChildren: numberOfChildren,
      });
    } else if (!selectedPart.root) {
      hidePanel();
      setState({ deleteItem: selectedPart, action: "confirm", fathersItemSelected: null, numberOfChildren: null });
    }
  }

  const onConfirmDeletePart = async () => {
    if (isHeadOfTheTreeDocument(state.deleteItem, props.partRoot))
      //if I'm the document you've opened the outline for
      await deleteDocumentRootAsync({
        docRootId: state.deleteItem.id,
        currentDocumentPartId: props.currentDocumentPartId,
      });
    else
      await deleteDocumentPartAsync({
        linkedPartId: state.deleteItem.id,
        docPartId: props.partRoot.id,
        // deleteFromClient true | null
        deleteFromClient: props.currentDocumentPartId === props.partRoot.id ? true : null, //if I'm in the outline of the currently opened document
      });
    hidePanel();
  };

  return (
    <>
      <DocumentPropertiesMessagesModal
        isModalOpen={!(isNullish(state.action) || isNullish(state.deleteItem))}
        onHideModal={() => {
          hidePanel();
        }}
        deleteItem={state.deleteItem}
        action={state.action}
        fathersItemSelected={state.fathersItemSelected}
        numberOfChildren={state.numberOfChildren}
        onFathersConfirm={checkFathers}
        onConfirmDeletePart={onConfirmDeletePart}
      />
    </>
  );
};
